import { render } from "./FestivalEventsOverview.vue?vue&type=template&id=03f27d10&ts=true"
import script from "./FestivalEventsOverview.vue?vue&type=script&lang=ts"
export * from "./FestivalEventsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/amff-2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__